<template>
    <v-container fluid class="pa-0 ma-0 primary fill-height">

        <v-layout wrap mt-4 pt-4>
            <v-flex mt-4 pt-4 xs12 lg8 offset-lg2 xl6 offset-xl3 px-3 text-xs-center>
                <v-img :src="require('@/assets/img/logo_dark.png')" width="300" cover class="mx-auto"/>

                <v-progress-linear
                    v-if="loading"
                    color="white"
                    :indeterminate="true"
                    :height="2"
                ></v-progress-linear>
                <v-alert v-else color="white" class="black--text mt-4" :value="true">
                    <div class="headline font-weight-light">{{ message.title }}</div>
                    <p class="subheading">{{ message.subtext }}</p>
                    <v-btn v-if="paymentUrl" depressed color="primary" round @click="toRetryPayment">
                        Reintentar
                    </v-btn>
                </v-alert>

            </v-flex>
        </v-layout>

    </v-container>
</template>

<script>

import {ApiUtils} from "@/utils/ApiUtils";

export default {
    components: {},
    data() {
        return {
            loading: false,
            status: 'pending',
            paymentUrl: null,
        }
    },
    async mounted() {
        const vm = this
        await vm.loadPayment()
    },
    computed: {
        eventId(vm = this) {
            return vm.$route.params.eventId
        },
        message(vm = this) {
            switch (vm.status) {
                case 'done':
                    return {title: '¡Gracias!', subtext: 'Tu pago ya ha sido procesado correctamente.'}
                case 'refuse':
                    return {
                        title: 'Pago rechazado',
                        subtext: 'No pudimos procesar tu pago. Intentalo nuevamente con otro medio de pago.'
                    }
                case 'cancel':
                    return {title: 'Has cancelado el pago', subtext: 'No hay problema, puedes intentarlo nuevamente.'}
                default:
                    return {title: '¡Gracias!', subtext: 'Te notificaremos cuando el pago haya sido procesado.'}
            }
        },
    },
    methods: {
        async loadPayment() {
            const vm = this
            vm.loading = true

            let response = await ApiUtils.makeGet(`appointments/${vm.eventId}/payment`)
            const json = await response.json()
            vm.status = json.result.status || 'pending'
            vm.paymentUrl = json.result.payment_url || null

            vm.loading = false
        },
        toRetryPayment() {
            const vm = this
            window.location.href = vm.paymentUrl
        }
    },
}
</script>